import React from 'react';

import Modal from "../../../component/modal/ModalTemplate";
import TextInput from "../../../component/input/TextInput";
import { PRIMARY_BTN, SECONDARY_BTN, INPUT, LABEL, FOOTER_CENTER } from "./modalStyle";

interface PhoneUpdateModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    updateAction: (uid: number) => void;
    setValue: (id: string, value: string) => void;
    uid: number;
    phoneName?: string;
    phoneList?: string[];
}

const PHONE_SLOT_COUNT = 10;

const PhoneUpdateModal: React.FC<PhoneUpdateModalProps> = ({
    isOpen, onRequestClose, updateAction, setValue, uid,
    phoneName = "", phoneList = Array(PHONE_SLOT_COUNT).fill(""),
}) => {
    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="전화번호 수정하기"
            className="react-modal"
        >
            <div className="modal-body tw-max-h-[500px] tw-overflow-y-auto">
                <div className="tw-mb-3">
                    <label className={LABEL}>전화번호명</label>
                    <TextInput
                        className={`${INPUT} tw-bg-[#F6F9FC] tw-text-[#A0A0A0]`}
                        type="text"
                        id="phoneName"
                        placeholder="특수문자는 입력 불가합니다."
                        value={phoneName}
                        onChange={setValue}
                        disabled={true}
                    />
                </div>
                <div>
                    <label className={LABEL}>등록 전화번호</label>
                    <div className="tw-space-y-2">
                        {Array.from({ length: PHONE_SLOT_COUNT }, (_, index) => (
                            <TextInput
                                key={index}
                                className={INPUT}
                                type="text"
                                id={`phoneNumber${index}`}
                                placeholder="-는 제외하고 입력해 주세요."
                                value={phoneList[index]}
                                onChange={setValue}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className={FOOTER_CENTER}>
                <button type="button" className={PRIMARY_BTN} onClick={() => updateAction(uid)}>수정</button>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>취소</button>
            </div>
        </Modal>
    );
};

export default PhoneUpdateModal;
